import React, { FC } from 'react';
import styles from './toggle.module.scss';

type Props = {
  checked: boolean;
  onChange: () => void;
};

export const Toggle: FC<Props> = ({ checked, onChange }) => (
  <span className={styles.toggleContainer}>
    <input
      className={styles.switch}
      type="checkbox"
      checked={checked}
      onChange={onChange}
    />
    <span className={styles.slider} />
  </span>
);
